function loadRenewalModule(component) {
  return () => import(`@/components/renewal/${component}.vue`)
}

export default [
  {
    name: 'renewal',
    path: '/renewal',
    component: () => import(/* webpackChunkName: "organization-view-page" */ '../view/RenewalView.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: 'renewal.history',
        path: 'history',
        component: loadRenewalModule('Index'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'renewal.view',
        path: 'view/:quotationId',
        props: true,
        component: loadRenewalModule('View'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'renewal.uploadFile',
        path: 'upload-file',
        component: loadRenewalModule('UploadFile'),
        props: true,
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'renewal.UploadReport',
        path: 'upload-report',
        component: loadRenewalModule('UploadReport'),
        props: true,
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'renewal.payment',
        path: 'payment/:quotationId',
        component: loadRenewalModule('RenewalPayment'),
        props: true,
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'renewal.sendToCustomerSuccess',
        path: 'send-link-success/:quotationId',
        component: loadRenewalModule('SendToCustomer'),
        props: true,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
]
